let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l27dd")).then(() => parcelRequire('8Pn84'));